import React from 'react';
import 'semantic-ui-css/components/modal.min.css';
import { Button, Checkbox, Header, Icon, Modal } from 'semantic-ui-react';
import {
    PRODUCT_LIST_TABLE_COLUMNS,
    ProductListColumnId,
    ProductListColumnVisibility,
} from './product.list.table-columns';
import './product.list.columns-modal.scss';

/** Mount inside `.admin-layout-content` so the modal inherits admin theme variables and form styling. */
function getAdminModalMountNode(): HTMLElement | undefined {
    if (typeof document === 'undefined') {
        return undefined;
    }
    return document.getElementById('admin-modal-mount') ?? document.body;
}

type Props = {
    open: boolean;
    draft: ProductListColumnVisibility;
    onDraftChange: (next: ProductListColumnVisibility) => void;
    onClose: () => void;
    onApply: () => void;
};

export default function ProductListColumnsModal({ open, draft, onDraftChange, onClose, onApply }: Props) {
    const toggle = (id: ProductListColumnId) => {
        onDraftChange({ ...draft, [id]: !draft[id] });
    };

    return (
        <Modal
            open={open}
            onClose={onClose}
            size="small"
            closeOnDimmerClick={false}
            className="admin-product-columns-modal"
            mountNode={getAdminModalMountNode()}
        >
            <Modal.Header>
                <Icon name="columns" /> Хүснэгтийн багана
            </Modal.Header>
            <Modal.Content scrolling className="admin-product-columns-modal__content">
                <Header as="h4" disabled>
                    Харагдах багануудыг сонгоно уу.
                </Header>
                <div className="admin-product-columns-checklist">
                    {PRODUCT_LIST_TABLE_COLUMNS.map((c) => (
                        <Checkbox
                            key={c.id}
                            label={c.label}
                            checked={draft[c.id]}
                            onChange={() => toggle(c.id)}
                        />
                    ))}
                </div>
            </Modal.Content>
            <Modal.Actions>
                <Button onClick={onClose}>Болих</Button>
                <Button primary onClick={onApply}>
                    Хадгалах
                </Button>
            </Modal.Actions>
        </Modal>
    );
}
